import clsx from "clsx"
import loadingGif from "@/assets/loading.gif"

const LoadingOverlay = ({ isVisible }: { isVisible: boolean }) => {
  return (
    <div
      className={clsx(
        "fixed inset-0 z-50 flex items-center justify-center bg-black transition-all",
        {
          hidden: !isVisible,
        }
      )}
      style={{
        background: "radial-gradient(circle , black 10%, rgba(0,0,0,0.7))",
      }}
    >
      <div className="flex h-[100px] w-[100px] items-center justify-center overflow-hidden">
        <img
          src={loadingGif}
          alt="Loading..."
        />
      </div>
    </div>
  )
}

export default LoadingOverlay
